import { CrFilter } from '../../../../customer-review-star-filter/types';
import { decodeJSONFromDataAttribute, EncodedJSONAttribute } from '../../../../_common/encode-decode-json-for-data-attribute';
import { PagesForCrFilters } from '../../../types';

export function updateLastPageInHtml(filter: CrFilter, listWrapperRootElement: HTMLElement) {
    const pagesForCurrentFilter = readPagesForCurrentFilterFromHtml(filter, listWrapperRootElement);
    if (pagesForCurrentFilter) {
        setLastPageInHtml(pagesForCurrentFilter, listWrapperRootElement);
    }
}

function readPagesForCurrentFilterFromHtml(filter: CrFilter, listWrapperRootElement: HTMLElement): number | null {
    const encodedPagesForFiltersJson = listWrapperRootElement.getAttribute('data-pages-for-cr-filters');
    if (!encodedPagesForFiltersJson) {
        return null;
    }

    const pagesForCrFilters = decodeJSONFromDataAttribute(encodedPagesForFiltersJson as EncodedJSONAttribute<PagesForCrFilters>);
    return pagesForCrFilters[filter];
}

function setLastPageInHtml(lastPageForCurrentFilter: number, listWrapperRootElement: HTMLElement) {
    const lastPageHtmlElement = findHtmlElementLastPage(listWrapperRootElement);
    if (lastPageHtmlElement) {
        lastPageHtmlElement.textContent = `${lastPageForCurrentFilter}`;
    }
}

function findHtmlElementLastPage(listWrapperRootElement: HTMLElement) {
    return listWrapperRootElement.querySelector<HTMLElement>('.js_cr_list-wrapper__pagination-last-page');
}
